'use strict';

var url = require('../../../../../utils/common/url.js');
var ExlyImage_constants = require('../constants/ExlyImage.constants.js');
var isImageFromOptimizingCdn = require('./isImageFromOptimizingCdn.js');

/**
 * Function to fetch a 16x16 favicon image to avoid loading heavy images in tab title favicons.
 * width is set to 16*2 since 16px being a really small size and favicon looks blurred in some low quality images.
 */
var getOptimisedFaviconUrl = function (imageUrl, cdnBaseUrl) {
    if (isImageFromOptimizingCdn.isImageFromOptimizingCdn(imageUrl, cdnBaseUrl)) {
        return url.appendURLSearchParams(imageUrl, {
            format: ExlyImage_constants.IMAGE_CDN_FORMATS.AUTO,
            width: 32,
        });
    }
    return imageUrl;
};

exports.getOptimisedFaviconUrl = getOptimisedFaviconUrl;
//# sourceMappingURL=getOptimisedFaviconUrl.js.map
